export default __webpack_public_path__ + "static/media/more-digital-library.cb16b853.svg";